export default "__VITE_ASSET__53f881ac__"